import React, {useEffect, useState} from 'react';
import {
    Backdrop,
    CircularProgress,
    Paper,
    Box,
    makeStyles,
    Typography,
    TextField,
} from '@material-ui/core';
import {Alert, Autocomplete} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import theme from '../styles/theme';
import PingTreesTable from './PingTrees/PingTreesTable';

const usePingTreesStyle = makeStyles({
    root: {
        '& .MuiPaper-root': {
            boxShadow: 'none',
        },
        '& .MuiToolbar-root': {
            paddingRight: theme.spacing(1),
            paddingLeft: theme.spacing(1),
        },
    },
    autoComplete: {
        marginBottom: '15px'
    }

});

const useIconStyles = makeStyles({
    primary: {
        backgroundColor: theme.palette.primary.main,
    },
    secondary: {
        backgroundColor: theme.palette.secondary.main,
    },
});

const PingTrees = props => {
    const classes = useStyles();
    const pingTreeClasses = usePingTreesStyle();
    const useIconClasses = useIconStyles();
    const [allPingTrees, setAllPingTrees] = useState([]);
    const [selectedTree, setSelectedTree] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const {loading, error, data, refetch} = useQuery(gql`
        {
            allPingTree {
                nodes {
                    id
                    name
                    campaigns {
                        id
                        active
                        name
                        pricePoint
                        portfolio {
                            id
                            name
                        }
                        servicer {
                            id
                            name
                        }
                        status
                        type
                    }
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
    });

    /**
     * Set Default Values when mounted
     */
    useEffect(() => {
        if (data && Object.keys(data).length) {
            setAllPingTrees(data.allPingTree.nodes);
        }
    }, [data]);

    /**
     * Handle AutoComplete Change - To Update selected tree
     */
    const handelChange = (e, val) => {
        setIsLoading(true);
        setSelectedTree(val);
        setTimeout(() =>
                setIsLoading(false)
            , [2000]);
    };
    /**
     * Ping Tree Tabs
     */
    const PingTreeTabs = () => (
        <Autocomplete
            className={`${classes.autoComplete} ${pingTreeClasses.autoComplete}`}
            value={selectedTree}
            onChange={(e, val) => handelChange(e, val)}
            renderInput={params => <TextField {...params} label="Ping Trees" variant="outlined" fullWidth/>}
            options={allPingTrees}
            getOptionLabel={option => option.name}
        />
    );


    /**
     * Campaign Tree Table
     */
    const CampaignTreeTable = () => (
        <>
            {allPingTrees.map((pingTree, idx) => (
                <Box
                    key={pingTree.id}
                    component="div"
                    role="tabpanel"
                    hidden={selectedTree.name !== pingTree.name}
                    id={`campaign-tabpanel-${idx}`}
                    aria-labelledby={`campaign-tab-${idx}`}
                    className={pingTreeClasses.root}
                >
                    {selectedTree.name === pingTree.name &&
                    <PingTreesTable
                        useIconClasses={useIconClasses}
                        refetch={refetch}
                        data={pingTree.campaigns}
                    />
                    }
                </Box>
            ))}
        </>
    );

    if (loading || isLoading) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    return (
        <>
            <Typography variant="h2">
                {selectedTree ? `${selectedTree.name} - ` : null} Campaigns List
            </Typography>
            <Paper className={classes.paper}>
                {!loading && error ? (
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                ) : null}
                {!loading && allPingTrees.length ? (
                    <>
                        <PingTreeTabs/>
                        {!selectedTree ? (
                            <Alert severity="warning">Please select a ping-tree in the dropdown to see their
                                campaigns.</Alert>
                        ) : (
                            <CampaignTreeTable/>
                        )}
                    </>
                ) : null}
            </Paper>
        </>
    )
};

export default PingTrees;
